import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { ProjectionEvaluationRangeId } from '../model/focus-selector-projection-evaluation-range.enum';

export interface FocusSelectorSelectGoalRow {
    rowAndMetricId: number;
    projectionEvaluationColumn: ProjectionEvaluationRangeId;
}

export const focusSelectorSelectGoalRow = createAction<
    ActionType,
    FocusSelectorSelectGoalRow
>(ActionType.COACHING_FOCUS_SELECTOR__SELECT_GOAL_ROW);
